/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Ovulation from './ovulation';
import OvulationDetail from './ovulation-detail';
import OvulationUpdate from './ovulation-update';
import OvulationDeleteDialog from './ovulation-delete-dialog';

const OvulationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Ovulation />} />
    <Route path="new" element={<OvulationUpdate />} />
    <Route path=":id">
      <Route index element={<OvulationDetail />} />
      <Route path="edit" element={<OvulationUpdate />} />
      <Route path="delete" element={<OvulationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OvulationRoutes;
